import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import {
  createDirectLine,
  Components,
} from "botframework-webchat";

import "./App.css";
import Eva from "./assets/Eva.png";
import { useDispatch } from "react-redux";
import { addToast } from "./libs/redux/slices/toastReducer";
import EvaDashboard from "./EvaDashboard/EvaDashboard";
import { axiosInstance } from "./libs/axios/axiosInstance";

const MAX_RETRY = 3;

//connection status

const UNITIATED = 0;
const CONNECTING = 1;
const ONLINE = 2;
const TOKEN_EXPIRED = 3;
const FAILED_TO_CONNECT = 4;
const ENDED = 5;

function fontFamily(fonts) {
  return fonts.map(font => `'${font}'`).join(', ');
}

const WebChatComponent = () => {
  const dispatch = useDispatch();
  const [directLine, setDirectLine] = useState({});
  const stopRetry = useRef(0);

  const fetchDirectLineToken = useCallback(async () => {
    const URL = "directline/v2/token";
    const accessToken = "Bearer " + localStorage.getItem("access_token");
    try {
      const response = await axiosInstance.post(URL, {}, {
        headers: {
          Authorization: accessToken,
        },
      })
      if (response.status === 200) {
        setDirectLine(response.data);
      }
    } catch (error) {
      console.error("Error fetching Directline token:", error);
      dispatch(addToast({
        type: "error",
        title: "Failed to fetch chatbot",
      }));
    }
  }, []);

  const fetchRefreshDirectLineToken = useCallback(async () => {
    const URL = `directline/v2/refresh-token?prevToken=${directLine.token}`;
    try {
      const response = await axiosInstance.post(URL, {}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
      if (response.status === 200) {
        setDirectLine(response.data);
      }
    } catch (error) {
      console.error("Error refreshing Direct Line token:", error);
      dispatch(addToast({
        type: "error",
        title: "Failed to refresh session eva",
      }));
    }
  }, [directLine])

  useEffect(() => {
    fetchDirectLineToken();
  }, [])

  useEffect(() => {
    if (directLine.token) {
      const timeOut = setTimeout(() => {
        fetchRefreshDirectLineToken();
      }, (directLine.expires_in - (directLine.expires_in * 0.3)) * 1000)
      return () => clearTimeout(timeOut);
    }
  }, [directLine])

  const directline = useMemo(() => createDirectLine({
    token: directLine.token,
    webSocket: true,
  }), [directLine]);

  useEffect(() => {
    directline.connectionStatus$.subscribe(connectionStatus => {
      if (connectionStatus === ONLINE) {
        console.log('connectionStatus : connected');
      } else if (connectionStatus === FAILED_TO_CONNECT) {
        if (stopRetry.current <= MAX_RETRY) {
          fetchDirectLineToken();
          stopRetry.current = stopRetry.current + 1;
        }
      }
    });
  }, [directline]);

  const adaptiveCardHostConfig = useMemo(() => (
    {
      "hostCapabilities": {
        "capabilities": null
      },
      "choiceSetInputValueSeparator": ",",
      "supportsInteractivity": true,
      "fontTypes": {
        "default": {
          "fontFamily": "System UI, Segoe UI, Arial",
          "fontSizes": {
            "small": 16,
            "default": 16,
            "medium": 16,
            "large": 16,
            "extraLarge": 16
          },
          "fontWeights": {
            "lighter": 200,
            "default": 400,
            "bolder": 600
          }
        },
        "monospace": {
          "fontFamily": "'Courier New', Courier, monospace",
          "fontSizes": {
            "small": 16,
            "default": 16,
            "medium": 16,
            "large": 16,
            "extraLarge": 16
          },
          "fontWeights": {
            "lighter": 200,
            "default": 400,
            "bolder": 600
          }
        }
      },
      "spacing": {
        "small": 3,
        "default": 8,
        "medium": 20,
        "large": 30,
        "extraLarge": 40,
        "padding": 10
      },
      "separator": {
        "lineThickness": 1,
        "lineColor": "#EEEEEE"
      },
      "imageSizes": {
        "small": 40,
        "medium": 80,
        "large": 160
      },
      "containerStyles": {
        "default": {
          "foregroundColors": {
            "default": {
              "default": "#FFFFFF",
              "subtle": "#FFFFFF",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "dark": {
              "default": "#000000",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "light": {
              "default": "#000000",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "accent": {
              "default": "#000000",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "good": {
              "default": "#000000",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "warning": {
              "default": "#ED1C24",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "attention": {
              "default": "#ED1C24",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            }
          },
          "backgroundColor": "#303030"
        },
        "emphasis": {
          "foregroundColors": {
            "default": {
              "default": "#000000",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "dark": {
              "default": "#000000",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "light": {
              "default": "#000000",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "accent": {
              "default": "#000000",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "good": {
              "default": "#000000",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "warning": {
              "default": "#000000",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            },
            "attention": {
              "default": "#000000",
              "subtle": "#66000000",
              "highlightColors": {
                "default": "#22000000",
                "subtle": "#11000000"
              }
            }
          },
          "backgroundColor": "#303030"
        }
      },
      "actions": {
        "maxActions": 100,
        "spacing": "Default",
        "buttonSpacing": 8,
        "showCard": {
          "actionMode": "Inline",
          "inlineTopMargin": 8,
          "style": "emphasis"
        },
        "Submit": {
          "actionMode": "Inline",
          "inlineTopMargin": 8,
          "style": "positive"
        },
        "preExpandSingleShowCardAction": true,
        "actionsOrientation": "horizontal",
        "actionAlignment": "left",
        "wrap": true,
        "buttonSpacing": 8
      },
      "adaptiveCard": {
        "allowCustomStyle": true
      },
      "imageSet": {
        "maxImageHeight": 100
      },
      "media": {
        "allowInlinePlayback": true
      },
      "factSet": {
        "title": {
          "size": "Default",
          "color": "Default",
          "isSubtle": false,
          "weight": "Bolder",
          "wrap": true
        },
        "value": {
          "size": "Default",
          "color": "Default",
          "isSubtle": false,
          "weight": "Default",
          "wrap": true
        },
        "spacing": 8
      },
      "cssClassNamePrefix": null,
      "_legacyFontType": {
        "fontFamily": "System UI, Segoe UI, Arial",
        "fontSizes": {
          "small": 12,
          "default": 14,
          "medium": 17,
          "large": 21,
          "extraLarge": 26
        },
        "fontWeights": {
          "lighter": 200,
          "default": 400,
          "bolder": 600
        }
      }
    }
  ))

  const styleOptions = useMemo(() => ({
    paddingRegular: 10,
    // paddingWide: 10 * 2,

    backgroundColor: "#212124",
    primaryFont: fontFamily(["System UI", "Segoe UI", "Arial"]),
    avatarSize: 40,
    botAvatarBackgroundColor: "white",
    botAvatarImage: Eva,
    botAvatarInitials: "EV",
    showAvatarInGroup: true,

    bubbleBackground: "#303030",
    bubbleBorderColor: "#303030",
    bubbleBorderRadius: 5,


    bubbleMaxWidth: 540, // Based off screen width = 600px
    bubbleFromUserBackground: "#28283C",
    bubbleFromUserBorderColor: "#303030",
    bubbleFromUserBorderRadius: 5,
    bubbleFromUserTextColor: "white",
    bubbleImageHeight: "40vh",
    bubbleTextColor: "white",

    sendBoxBorderRadius: 5,
    sendBoxBorderStyle: "solid",
    sendBoxBackground: "#303030",
    sendBoxButtonColor: "white",
    sendBoxPlaceholderColor: "white",
    sendBoxTextColor: "white",
    hideUploadButton: true,
    hideSendBox: false,

    timestampFormat: "absolute",
    scrollToEndButtonFontSize: 8,

    typingAnimationBackgroundImage: `url('/svg-spinners--3-dots-fade.svg')`,
    typingAnimationDuration: 86400000,
    typingAnimationHeight: 24,
    typingAnimationWidth: 64,

    adaptiveCardsParserMaxVersion: '1.5',
    cardEmphasisBackgroundColor: '#F9F9F9',
    cardPushButtonBackgroundColor: '#0063B1',
    cardPushButtonTextColor: 'White',
    richCardWrapTitle: false,
    accent: 'white',
  }), []);

  return (
    <>
      {
        directLine.token && (
          <Components.Composer
            directLine={directline}
            styleOptions={styleOptions}
            adaptiveCardsHostConfig={adaptiveCardHostConfig}
          >
            <Components.AccessKeySinkSurface>
              <EvaDashboard />
              <Components.BasicWebChat className="webchat-container" />
            </Components.AccessKeySinkSurface>
          </Components.Composer>
        )
      }
    </>
  )
};

export default WebChatComponent;